import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import { getErrorMessage, formatDecimal } from '../../utils/helper'

const ApplePayDataCap = (props) => {
    const {faciltyData, getValues, onSubmit, setIsSubmittingForm, setIsLoading, notify, payableAmount } = props

    useEffect(() => {
        window.DatacapApplePay.init(
            tokenCallback, 
            faciltyData?.facility_payment_details?.wallet_datacap_token,
            faciltyData?.facility_payment_details?.wallet_datacap_mid,
            faciltyData?.facility_payment_details?.wallet_datacap_ios_merchant,
            // '2546bc0ec6304d92a576a84699624456', 
            // 'PARKESANJ5EI', 
            // 'Y29tLnBhcmtlbmdhZ2Uuc3RhZ2luZy10cmFuc2llbnQuUEFSS0VTQU5KNQ==', 
            formatDecimal(payableAmount)
        )
        // window.DatacapApplePay.init(tokenCallback, '2546bc0ec6304d92a576a84699624456', 'PARKESANJ5EI', 'Y29tLnBhcmtlbmdhZ2Uuc3RhZ2luZy10cmFuc2llbnQuUEFSS0VTQU5KNQ==', '10')
    }, [faciltyData])

    // const finalCall = (tokenResponse) => {
    //     console.log('tokenResponse',tokenResponse)
    //     notify('success', tokenResponse)

    //     return new Promise((resolve, reject) => {
    //         // Token error!
    //         if (tokenResponse.Error) {
    //             alert('Token error: ' + tokenResponse.Error)
    //             reject('Token error: ' + tokenResponse.Error)
    //         } else {
    //             // Good token! Send it to POS server for payment processing
    //             // Replace the fetch call with your actual API call
    //             fetch('https://your-server-for-receiving-order-info/', {
    //                 method: 'POST',
    //                 body: JSON.stringify(tokenResponse)
    //             }).then((paymentResponse) => {
    //                 paymentResponse.json().then((json) => {
    //                     console.log('json', json)
    //                     // Use Datacap's Pay API HTTP status to determine how to return promise 
    //                     if (paymentResponse.status !== 200) {
    //                         reject('Error: ' + json.Message)
    //                     } else {
    //                         resolve('Approved: ' + json.Message)
    //                     }
    //                 })
    //             }).catch((error) => {
    //                 reject('Error: ' + error)
    //             })
    //         }
    //     })
    // }
    const tokenCallback = function (tokenResponse) {
		return new Promise(function (resolve, reject) {

			// If error, show error
			if (tokenResponse.Error) {
				alert('Token error: ' + tokenResponse.Error)
                
				return
			}

			// If good, call Pay API
			var token = tokenResponse.Token

			var headers = {}
			headers['Content-Type'] = 'application/json; charset=utf-8'
			headers['Authorization'] = faciltyData?.facility_payment_details?.wallet_datacap_mid 								// !!! For demonstration only -- never expose MerchantID !!!
            headers['Accept-Encoding'] = 'br, gzip, deflate'
            headers['Accept-Language'] = 'en-us'
            headers['Connection'] = 'keep-alive'
            headers['Host'] = 'pay.dcap.com'
            var payApiRequest = [
				{ Amount: formatDecimal(payableAmount), Token: token }			
			]
            setIsSubmittingForm(true)
            setIsLoading(true)

			fetch('https://pay.dcap.com/v1/credit/sale', {
				method: 'POST',
				body: JSON.stringify(payApiRequest),
				headers: headers
			}).then(function (payApiResponse) {

				payApiResponse.json().then(function (json) {
                    setIsSubmittingForm(false)
                    // setIsLoading(false)
					if (payApiResponse.status && payApiResponse.status != 200) {
						notify('error', 'Error: ' + json.Message)
                        const formData = getValues()
                        const finalData = {...formData, walletPay : json}
                        finalData.paymentMethods = 'APL'
                        reject('Error' + json.Message)
                        onSubmit(finalData)
                        
					}
					else {
						const formData = getValues()
                        const finalData = {...formData, walletPay: json}
                        finalData.paymentMethods = 'APL'
                        resolve('Approved' + json.Message)
                        onSubmit(finalData)
					}
				})
			}).catch((err) => {
                setIsSubmittingForm(false)
                setIsLoading(false)
                notify('error', err ? err : getErrorMessage(err) )
            })
		})
	}	

    
    return (
            <div className="buttonWrapper px-2">
                <div className='payButton p-2 d-flex justify-content-center' id='apple-pay-button' />
            </div>
    )
}
ApplePayDataCap.propTypes = {
    faciltyData: PropTypes.object,
    getValues: PropTypes.func, 
    onSubmit: PropTypes.func,
    setIsSubmittingForm: PropTypes.func,
    setIsLoading: PropTypes.func,
    notify: PropTypes.func,
    payableAmount: PropTypes.number,
}

ApplePayDataCap.defaulProps = {
    faciltyData: EMPTY_OBJECT,
    getValues: noop, 
    onSubmit: noop,
    setIsSubmittingForm: noop,
    setIsLoading: noop,
    notify: noop,
    payableAmount: null,
}

function mapStateToProps() {

    return {
        
    }
}

export default connect(mapStateToProps)(ApplePayDataCap)